// Events
export const EVENT_ANNUAL_BILLING_NUDGE = 'clicked annual billing nudge';
export const EVENT_TEAMS_DOWNGRADED_BANNER = 'clicked teams downgraded banner';
export const EVENT_TRACK_TRIAL_BANNER = 'Trial: clicked banner';

// URLs
export const BILLING_SETTINGS_URL = '/app/settings/billing';
export const PRICING_PAGE_URL = '/app/billing/plans';
export const UPGRADE_BASE_URL = '/app/billing/plans/upgrade';
